"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BALANCE_FOCUS = void 0;
var BALANCE_FOCUS;
(function (BALANCE_FOCUS) {
    BALANCE_FOCUS["THIS_MONTH"] = "THIS_MONTH";
    BALANCE_FOCUS["LAST_MONTH"] = "LAST_MONTH";
})(BALANCE_FOCUS = exports.BALANCE_FOCUS || (exports.BALANCE_FOCUS = {}));
